export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "highlight_worker.6ebdabe6.worker.js");
}
